import { createSelector } from 'reselect';
import { CustomReportTypes } from '../../../shared/customReports/constants';

export const customReportsSelector = ({ administration }) =>
  administration.customReports.customReports;

export const openFormForAddSelector = ({ administration }) =>
  administration.customReports.openFormForAdd;

export const openFormForEditSelector = ({ administration }) =>
  administration.customReports.openFormForEdit;

export const customReportIdSelector = ({ administration }) =>
  administration.customReports.customReportToEditId;

export const isFetchingCustomReportsSelector = ({ administration }) =>
  administration.customReports.isFetchingCustomReports;

export const isTestCustomReportQueryInProgressSelector = ({ administration }) =>
  administration.customReports.isTestCustomReportQueryInProgress;

export const customReportDataSelector = ({ administration }) =>
  administration.customReports.customReportData;

export const readOnlySelector = ({ administration }) =>
  administration.customReports.readOnly;

export const isSavingCustomReportQueryInProgressSelector = ({ administration }) =>
  administration.customReports.isSavingCustomReportQueryInProgress;

export const customReportSelector = createSelector(
  customReportsSelector,
  customReportIdSelector,
  (customReports, customReportToEditId) =>
    customReports.find(customReport => customReport.reportSetId === customReportToEditId)
);

export const isReportSetOpenSelector = state => {
  const reportToEdit = customReportSelector(state);
  if (reportToEdit) {
    return reportToEdit.customReportType === CustomReportTypes.REPORT_SET;
  }
  return state.administration.customReports.isAddingReportSet;
};

export const wasVerifyingCustomReportParamQuerySuccessfulSelector = ({ administration }) =>
  administration.customReports.wasVerifyingCustomReportParamQuerySuccessful;

export const isVerifyingParamToEditQuerySelector = ({ administration }) =>
  administration.customReports.isVerifyingParamToEditQuery;

export const customReportParamsSelector = ({ administration }) =>
  administration.customReports.customReportParams;

export const isFetchingCustomReportParamsSucceedSelector = ({ administration }) =>
  administration.customReports.isFetchingCustomReportParams;

export const rowToScrollToSelector = ({ administration }) =>
  administration.customReports.rowIndexToScrollTo;

export const addedReportIdSelector = ({ administration }) =>
  administration.customReports.addedReportId;

export const reportParamToEditOptionsSelector = ({ administration }) =>
  administration.customReports.reportParamToEditOptions;

export const isDeletingCustomReportSelector = ({ administration }) =>
  administration.customReports.isDeletingInProgress;
